import { FC, ReactNode } from 'react';
import { cn } from '@fe-learner-common';

interface EmptyStateProps {
  icon?: ReactNode;
  label: string;
  description: string;
}

const Row = ({ icon, className }: { icon: ReactNode; className?: string }) => {
  return (
    <div
      className={cn(
        'lf:flex lf:items-center lf:gap-2 lf:rounded-lg lf:bg-neutral-100 lf:p-2',
        className,
      )}
    >
      {icon}
      <div className="lf:flex lf:flex-1 lf:flex-col">
        <div className="lf:h-1 lf:w-12 lf:rounded-xs lf:bg-neutral-550" />
        <div className="lf:mt-1 lf:h-1 lf:w-full lf:rounded-xs lf:bg-neutral-550" />
      </div>
    </div>
  );
};

export const EmptyState: FC<EmptyStateProps> = ({
  icon,
  label,
  description,
}) => {
  return (
    <div className="lf:flex lf:flex-col lf:items-center lf:gap-10 lf:p-10">
      <div className="lf:flex lf:w-[240px] lf:flex-1 lf:flex-col lf:gap-1">
        <Row icon={icon} />
        <Row icon={icon} className="lf:opacity-60" />
        <Row icon={icon} className="lf:opacity-30" />
      </div>
      <div className="lf:flex lf:flex-col lf:gap-4 lf:text-center">
        {label && <h2 className="lf:text-title-md">{label}</h2>}
        {description && (
          <p className="lf:text-body-md lf:text-neutral-500">{description}</p>
        )}
      </div>
    </div>
  );
};

interface EmptyStateWrapperProps extends EmptyStateProps {
  children: ReactNode;
  condition?: boolean | null;
}

export const EmptyStateWrapper: FC<EmptyStateWrapperProps> = ({
  children,
  condition,
  ...rest
}) => {
  return condition ? children : <EmptyState {...rest} />;
};
